/**
 * WhatsApp-style date separator labels using browser local timezone.
 */
export function getLocalDateKey(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatMessageBubbleTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
}

export function formatChatDateSeparator(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  const todayKey = getLocalDateKey(now.toISOString());
  const msgKey = getLocalDateKey(iso);

  if (msgKey === todayKey) return 'Today';

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (msgKey === getLocalDateKey(yesterday.toISOString())) return 'Yesterday';

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfMsg = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((startOfToday - startOfMsg) / 86400000);
  if (diffDays > 0 && diffDays < 7) {
    return d.toLocaleDateString(undefined, { weekday: 'long' });
  }

  return d.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function groupMessagesWithDateSeparators(messages) {
  if (!messages?.length) return [];
  const items = [];
  let lastDateKey = null;

  messages.forEach((message) => {
    const dateKey = getLocalDateKey(message.created_at);
    if (dateKey && dateKey !== lastDateKey) {
      items.push({
        type: 'separator',
        id: `sep-${dateKey}`,
        label: formatChatDateSeparator(message.created_at),
        dateKey,
      });
      lastDateKey = dateKey;
    }
    items.push({ type: 'message', id: `msg-${message.id}`, message });
  });

  return items;
}
